<div class="buttons-container">
  <button
    matSuffix
    mat-flat-button
    color="primary"
    aria-modal="true"
    aria-label="add catchment"
    [matMenuTriggerFor]="addCatchmentMenu"
    [disabled]="
      (generatingCatchmentInProgress$ | async) ||
      (isCatchmentReportingReadonlySystem$ | async)
    "
    i18n-aria-label="@@addCatchmentButtonAriaLabel"
    >
    @if (!(generatingCatchmentInProgress$ | async)) {
      <div class="add-catchment-button">
        <mat-icon>add</mat-icon>
        <div class="text" i18n="@@addCatchmentButtonText">Add Catchment</div>
      </div>
    } @else {
      <mat-spinner
        class="update-button-spinner"
        style="width: 120px"
        diameter="24"
        strokeWidth="2"
        i18n-aria-label="@@loadingSpinnerAriaLabel"
        aria-label="Loading"
        >
      </mat-spinner>
    }
  </button>

  <mat-menu #addCatchmentMenu="matMenu">
    <button
      mat-menu-item
      (click)="onAddCatchment(locatorShapeType.Circle)"
      [disabled]="isDisabled(locatorShapeDefaults?.circle)"
      >
      <mat-icon class="atlas-icon icon-circle"></mat-icon>
      <span i18n="@@circleMenuItem">Circle</span>
    </button>
    <button
      mat-menu-item
      (click)="onAddCatchment(locatorShapeType.Car)"
      [disabled]="isDisabled(locatorShapeDefaults?.car)"
      >
      <mat-icon>directions_car</mat-icon>
      <span i18n="@@driveMenuItem">Drive</span>
    </button>
    <button
      mat-menu-item
      (click)="onAddCatchment(locatorShapeType.PublicTransport)"
      [disabled]="isDisabled(locatorShapeDefaults?.publicTransport)"
      >
      <mat-icon>train</mat-icon>
      <span i18n="@@publicTransportMenuItem">Public Transport</span>
    </button>
    <button
      mat-menu-item
      (click)="onAddCatchment(locatorShapeType.Walk)"
      [disabled]="isDisabled(locatorShapeDefaults?.walk)"
      >
      <mat-icon>directions_walk</mat-icon>
      <span i18n="@@walkMenuItem">Walk</span>
    </button>
    @if (!areMultipleLocationsSelected) {
      <button
        mat-menu-item
        (click)="onAddPolygon()"
        [disabled]="isDisabled(locatorShapeDefaults?.polygon)"
        >
        <mat-icon class="material-symbols-outlined"> activity_zone </mat-icon>
        <span i18n="@@polygonMenuItem">Polygon</span>
      </button>
    }
  </mat-menu>

  @if (
    selectedShape &&
    selectedShape.type !== locatorShapeType.FreeForm &&
    selectedShape.type !== locatorShapeType.FreeFormLocked
    ) {
    <button
      matSuffix
      mat-flat-button
      class="secondary-button"
      aria-label="edit catchment"
      (click)="onEditCatchment()"
    [disabled]="
      !enableEditMode || (isCatchmentReportingReadonlySystem$ | async)
    "
      i18n-aria-label="@@editCatchmentButtonAriaLabel"
      >
      <mat-icon>edit</mat-icon>
      <span i18n="@@editCatchmentButtonText">Edit Catchment</span>
    </button>
  }

  @if (selectedShape && selectedShape.type === locatorShapeType.FreeForm) {
    <button
      matSuffix
      mat-flat-button
      class="secondary-button"
      aria-label="edit catchment"
    [disabled]="
      !enableEditMode || (isCatchmentReportingReadonlySystem$ | async)
    "
      [matMenuTriggerFor]="editCatchmentMenu"
      i18n-aria-label="@@editCatchmentButtonAriaLabel"
      >
      <mat-icon>edit</mat-icon>
      <span i18n="@@editCatchmentButtonText">Edit Catchment</span>
    </button>
  }
  <mat-menu #editCatchmentMenu="matMenu">
    <button
      mat-menu-item
      (click)="onEditDescription()"
      i18n="@@editDescriptionMenuItem"
      >
      Edit Description
    </button>
    <button mat-menu-item (click)="onEditPolygon()" i18n="@@editShapeMenuItem">
      Edit Shape
    </button>
  </mat-menu>

  @if (
    selectedShape && selectedShape.type === locatorShapeType.FreeFormLocked
    ) {
    <button
      matSuffix
      mat-flat-button
      class="secondary-button"
      aria-label="edit catchment"
      [disabled]="true"
      [matMenuTriggerFor]="editCatchmentMenu"
      i18n-aria-label="@@editCatchmentButtonAriaLabel"
      >
      <mat-icon>edit</mat-icon>
      <span i18n="@@editCatchmentButtonText">Edit Catchment</span>
    </button>
  }
  <mat-menu #editCatchmentMenu="matMenu">
    <button
      mat-menu-item
      (click)="onEditDescription()"
      i18n="@@editDescriptionMenuItem"
      >
      Edit Description
    </button>
  </mat-menu>
</div>
